import { mutatorAction } from 'satcheljs';
import { setItem } from 'owa-local-storage';
import getMyOutlookViewState from '../store/myOutlookViewState';
import type { MyOutlookTab } from '../store/myOutlookViewState';
import type { ReengagementOpenEmailCta } from 'owa-personal-os-types';
import { setStoredScheduleVisible } from '../utils/scheduleVisibilityStorage';

const SECTION_HIDDEN_KEY = 'owa-personal-os-section-hidden';

export const setMyOutlookFullPageShowingMutator: (
    isShowing: boolean,
    initialTab?: MyOutlookTab
) => void = mutatorAction(
    'setMyOutlookFullPageShowingMutator',
    (isShowing: boolean, initialTab?: MyOutlookTab): void => {
        getMyOutlookViewState().isFullPageShowing = isShowing;
        if (initialTab) {
            getMyOutlookViewState().initialTab = initialTab;
        } else if (!isShowing) {
            getMyOutlookViewState().initialTab = 'today';
        }
    }
);

export const setMyOutlookSectionHiddenMutator: (hidden: boolean) => void = mutatorAction(
    'setMyOutlookSectionHiddenMutator',
    (hidden: boolean): void => {
        getMyOutlookViewState().isSectionHidden = hidden;
        setItem(self, SECTION_HIDDEN_KEY, hidden ? 'true' : 'false');
    }
);

export const setScheduleVisibleMutator: (visible: boolean) => void = mutatorAction(
    'setScheduleVisibleMutator',
    (visible: boolean): void => {
        const viewState = getMyOutlookViewState();
        viewState.isScheduleVisible = visible;
        // Remember the user's explicit choice so the next page visit defaults
        // to this state instead of the collapsed default.
        setStoredScheduleVisible(visible);
        // Explicit toggle wins over the detail-pane snapshot; clearing it
        // prevents `onDetailPaneClosed` from silently reverting this change.
        viewState.scheduleVisibleBeforeDetailPane = null;
    }
);

export const setHighlightedActionableItemsMutator: (ids: string[]) => void = mutatorAction(
    'setHighlightedActionableItemsMutator',
    (ids: string[]): void => {
        const current = getMyOutlookViewState().highlightedActionableItemIds;
        // Skip redundant writes so hovering non-citing sentences doesn't churn
        // the observable (and re-render the actionable rows) needlessly.
        if (current.length === ids.length && current.every((id, index) => id === ids[index])) {
            return;
        }
        getMyOutlookViewState().highlightedActionableItemIds = ids;
    }
);

export const setPendingReengagementActionMutator: (
    action: ReengagementOpenEmailCta | null
) => void = mutatorAction(
    'setPendingReengagementActionMutator',
    (action: ReengagementOpenEmailCta | null): void => {
        getMyOutlookViewState().pendingReengagementAction = action;
    }
);
